var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGem = function SvgGem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.791 3.175.672 6.259a1.764 1.764 0 0 0 0 2.493l.868.868 7.971-6.96H5.038a1.77 1.77 0 0 0-1.247.515Z",
    fill: "url(#gem_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.486 2.66 1.54 9.62l2.112 2.113L14.145 2.66h-5.66Z",
    fill: "url(#gem_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.727 2.66-9.074 9.073 2.112 2.112L17.15 4.177l-.92-.918a1.958 1.958 0 0 0-1.413-.603h-2.09v.005Z",
    fill: "url(#gem_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.292 3.32 5.765 13.846 7.88 15.96 18.914 5.945 16.292 3.32Z",
    fill: "url(#gem_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8.702 16.781-.822-.821L18.426 5.456l.87.871c.688.688.75 1.737.062 2.425l-8.07 8.031a1.83 1.83 0 0 1-2.586-.002Z",
    fill: "url(#gem_svg__e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_svg__a",
    x1: 0.094,
    y1: 9.458,
    x2: 4.877,
    y2: 4.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C774FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D677DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_svg__b",
    x1: 4.573,
    y1: 9.432,
    x2: 8.276,
    y2: 5.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D677DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_svg__c",
    x1: 8.775,
    y1: 9.273,
    x2: 12.149,
    y2: 6.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_svg__d",
    x1: 7.976,
    y1: 13.892,
    x2: 15.916,
    y2: 6.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gem_svg__e",
    x1: 10.554,
    y1: 15.386,
    x2: 18.272,
    y2: 7.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC846"
  })))));
};

export { SvgGem as ReactComponent };
export default "data:image/svg+xml;base64,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";